import { createSelector } from 'reselect';

const selectAccountWebPageCards = (state: any) => state.accountWebPageCards;


export const selectAccountWebPageCardsCurrentItem = createSelector([selectAccountWebPageCards], (accountWebPageCards) => accountWebPageCards.current);

export const selectAccountWebPageCardsListItems = createSelector([selectAccountWebPageCards], (accountWebPageCards) => accountWebPageCards.list);

export const selecAccountWebPageCardsItemById = (itemId: any) =>
    createSelector(selectAccountWebPageCardsListItems, (list) => list.result.items.find((item: any) => item._id === itemId));

export const selectAccountWebPageCardsQueryItems = createSelector([selectAccountWebPageCards], (accountWebPageCards) => accountWebPageCards.query);

export const selectAccountWebPageCardsCreatedItem = createSelector([selectAccountWebPageCards], (accountWebPageCards) => accountWebPageCards.create);

export const selectAccountWebPageCardsUpdatedItem = createSelector([selectAccountWebPageCards], (accountWebPageCards) => accountWebPageCards.update);

export const selectAccountWebPageCardsReadItem = createSelector([selectAccountWebPageCards], (accountWebPageCards) => accountWebPageCards.read);

export const selectAccountWebPageCardsDeletedItem = createSelector([selectAccountWebPageCards], (accountWebPageCards) => accountWebPageCards.delete);

export const selectAccountWebPageCardsSearchedItems = createSelector([selectAccountWebPageCards], (accountWebPageCards) => accountWebPageCards.search);

export const selectAccountWebPageCardsItemsCount = createSelector([selectAccountWebPageCards], (accountWebPageCards) => accountWebPageCards.count);

export const selectAccountWebPageCardsItemsFilter = createSelector([selectAccountWebPageCards], (accountWebPageCards) => accountWebPageCards.filter);

// Selector to get the list items for a specific id
export const selectAccountWebPageCardsListItemsById = (id: string) =>
    createSelector([selectAccountWebPageCards], (accountWebPageCards) => {
        if (!id || !accountWebPageCards[id]) {
            return []; // Return null or an empty state if `id` is invalid or not found
        }
        return accountWebPageCards[id].items;
    });
